// firebase.ts / firebase/config.ts
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCv_JXx_Od7AVqfccvRdZPLnltEOc3uHLg",
  authDomain: "capitalwave-67ce2.firebaseapp.com",
  projectId: "capitalwave-67ce2",
  storageBucket: "capitalwave-67ce2.firebasestorage.app",
  messagingSenderId: "54254476330",
  appId: "1:54254476330:web:958b80417545c7ff363753",
  measurementId: "G-305RR76S83",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Optional: export app if needed elsewhere
export { app };